import { render, staticRenderFns } from "./classRecord.vue?vue&type=template&id=ae95bea0&scoped=true"
import script from "./classRecord.vue?vue&type=script&lang=js"
export * from "./classRecord.vue?vue&type=script&lang=js"
import style0 from "./classRecord.vue?vue&type=style&index=0&id=ae95bea0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae95bea0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae95bea0')) {
      api.createRecord('ae95bea0', component.options)
    } else {
      api.reload('ae95bea0', component.options)
    }
    module.hot.accept("./classRecord.vue?vue&type=template&id=ae95bea0&scoped=true", function () {
      api.rerender('ae95bea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/record/classRecord.vue"
export default component.exports